import produce from 'immer';
import {
  types,
  CustomerState,
  CustomerActionTypes,
  SaveCustomerAsyncSuccess,
  SaveCustomerAsyncPending,
  SaveCustomerPayload,
  SaveSurveyAsyncSuccess,
  SaveSurveyAsyncPending,
  SaveSurveyAsyncError,
  GetCustomerPayload,
  GetCustomerAsyncSuccess,
  GetCustomerAsyncPending,
  GetCustomerAsyncError,
  SetLookupData,
  SetPhoneCountry,
  GetLocationsAsyncSuccess,
  GetLocationsAsyncPending,
  GetLocationsAsyncError,
  GetLocationsPayload,
  SetIsLocal
} from './types';

// Actions
export const actions = {
  getCustomer: (payload: GetCustomerPayload): CustomerActionTypes => ({
    type: types.GET_CUSTOMER_ASYNC.REQUEST,
    payload
  }),
  saveCustomer: (payload: SaveCustomerPayload): CustomerActionTypes => ({
    type: types.SAVE_CUSTOMER_ASYNC.REQUEST,
    payload
  }),
  saveSurvey: (payload: any): CustomerActionTypes => ({
    type: types.SAVE_SURVEY_ASYNC.REQUEST,
    payload
  }),
  setPhoneCountry: (payload: string): CustomerActionTypes => ({ type: types.SET_PHONE_COUNTRY, payload }),
  getLocations: (payload: GetLocationsPayload): CustomerActionTypes => ({
    type: types.GET_LOCATIONS_ASYNC.REQUEST,
    payload
  }),
  setIsLocal: (payload: boolean): CustomerActionTypes => ({ type: types.SET_IS_LOCAL, payload }),
  resetCustomer: () => ({ type: types.RESET_CUSTOMER }),
  resetError: () => ({ type: types.RESET_ERROR }),
  resetLocations: () => ({ type: types.RESET_LOCATIONS })
};

// Initial State
export const initialState: CustomerState = {
  customer: null,
  lookupData: null,
  survey: null,
  phoneCountry: undefined,
  loading: false,
  error: undefined,
  locations: null,
  isLocal: false
};

// Reducer
export const reducer = (state: CustomerState = initialState, action: CustomerActionTypes): CustomerState => {
  // eslint-disable-next-line consistent-return
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_CUSTOMER_ASYNC.SUCCESS:
        draft.customer = (action as GetCustomerAsyncSuccess).payload;
        break;
      case types.SAVE_CUSTOMER_ASYNC.SUCCESS:
        draft.customer = (action as SaveCustomerAsyncSuccess).payload;
        break;
      case types.SAVE_SURVEY_ASYNC.SUCCESS:
        draft.survey = (action as SaveSurveyAsyncSuccess).payload;
        break;
      case types.GET_LOCATIONS_ASYNC.SUCCESS:
        draft.locations = (action as GetLocationsAsyncSuccess).payload;
        break;
      case types.GET_CUSTOMER_ASYNC.PENDING:
      case types.GET_LOCATIONS_ASYNC.PENDING:
      case types.SAVE_CUSTOMER_ASYNC.PENDING:
      case types.SAVE_SURVEY_ASYNC.PENDING:
        draft.loading = (
          action as
            | SaveCustomerAsyncPending
            | SaveSurveyAsyncPending
            | GetCustomerAsyncPending
            | GetLocationsAsyncPending
        ).payload;
        break;
      case types.GET_CUSTOMER_ASYNC.ERROR:
        draft.error = (action as GetCustomerAsyncError).payload.message;
        break;
      case types.SAVE_CUSTOMER_ASYNC.ERROR:
        // Treating customer creation error as success to proceed with the flow
        draft.customer = { customerId: '' };
        break;
      case types.SAVE_SURVEY_ASYNC.ERROR:
      case types.GET_LOCATIONS_ASYNC.ERROR:
        draft.error = (action as SaveSurveyAsyncError | GetLocationsAsyncError).payload;
        break;
      case types.RESET_CUSTOMER:
        return initialState;
      case types.RESET_ERROR:
        draft.error = initialState.error;
        break;
      case types.RESET_LOCATIONS:
        draft.locations = initialState.locations;
        break;
      case types.SET_LOOKUP_DATA:
        draft.lookupData = (action as SetLookupData).payload;
        break;
      case types.SET_PHONE_COUNTRY:
        draft.phoneCountry = (action as SetPhoneCountry).payload;
        break;
      case types.SET_IS_LOCAL:
        draft.isLocal = (action as SetIsLocal).payload;
        break;
      default:
    }
  });
};
